import React, { Component } from 'react';

class Button extends Component {
  render() {
    let icon = null;
    let value = this.props.defaultText;
    const disableButton = this.props.isbusy || this.props.disableCriterion;
    let className = 'Button';

    if (this.props.icon) {
      icon = <i className={`fa ${this.props.icon}`}></i>;
    }

    if (this.props.isbusy) {
      value = this.props.busyText || this.props.defaultText;
      icon = <i className="fa fa-circle-o-notch m2spin"></i>;
    }

    if (this.props.size) {
      className = `Button-${this.props.size}`;
    }
    if (this.props.danger) {
      className = `${className} Button-danger`;
    }
    if (this.props.disableCriterion) {
      className = `${className} Button-disabled`;
    }

    return (
      <div className={className}>
        <button disabled={disableButton} onClick={this.props.onClick}>
          {' '}
          {icon} {value}{' '}
        </button>
      </div>
    );
  }
}

export default Button;
